import { render, staticRenderFns } from "./StepPopulateTemplateRecommends.vue?vue&type=template&id=73fa87e9&scoped=true&"
import script from "./StepPopulateTemplateRecommends.vue?vue&type=script&lang=js&"
export * from "./StepPopulateTemplateRecommends.vue?vue&type=script&lang=js&"
import style0 from "./StepPopulateTemplateRecommends.vue?vue&type=style&index=0&id=73fa87e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fa87e9",
  null
  
)

export default component.exports